import Axios from 'axios';
import { auth } from '../../../utils/auth';

export const getAxiosClient = async () => {
  const jwt = await auth.getJwt();
  if (!jwt) {
    return null;
  }
  return Axios.create({
    headers: { Authorization: `Bearer ${jwt}` },
  });
};
